/**
 * Tiny cross-navigation handoff for the "a run just started" signal (WEB-7818).
 *
 * When the user clicks Test run in the routines list, we navigate to the
 * routine's conversation and want it to show a "working" banner immediately.
 * A window event is race-prone — the freshly-mounted WorkspaceChat hasn't
 * registered its listener yet when the event fires. This module survives the
 * navigation: the click marks the conversation, and WorkspaceChat consumes it
 * on its next conversation-load. One-shot, so it never leaks a stale banner.
 */
let pendingConversationId: number | null = null;

export function markRunWorking(conversationId: number): void {
	pendingConversationId = conversationId;
}

/** Returns true once for the marked conversation, then clears it. */
export function consumeRunWorking(conversationId: number): boolean {
	if (pendingConversationId === conversationId) {
		pendingConversationId = null;
		return true;
	}
	return false;
}
